"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _message = _interopRequireDefault(require("element-ui/lib/message"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _axios = _interopRequireDefault(require("axios"));
var _router = _interopRequireDefault(require("../router"));
var _auth = require("@/utils/auth");
var _user = require("@/api/user");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _store = _interopRequireDefault(require("@/store"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * @Author: 1971167057@qq.com
 * @since: Do not edit
 * @lastTime: 2020-09-29 13:49:30
 * @LastAuthor: Do not edit
 * @FilePath: \yilong\src\utils\request.js
 * @Description: request拦截工具
 */
var whiteStatus = false;
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(to, form, next) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          whiteStatus = to.path === "/privacy";
          next();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
var _Message = _message.default;
var errCode = [1000, 1002, 1005]; // 1000 token违法 1001 token刷新 1002 token刷新失败 1003 修改当前账号退出 1005长时间不操作
// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 30 // request timeout
  // withCredentials: true,
  // transformRequest: [(data) => {
  //   const obj = {}
  //   for (const key in data) {
  //     if (data[key] !== null) {
  //       obj[key] = data[key]
  //     }
  //   }
  //   // Do whatever you want here, for example headers.Authorization = `Bearer ${jwt}`
  //   return obj
  // }, ...axios.defaults.transformRequest]
});
service.updateToken = function (token) {
  service.defaults.headers["token"] = token;
  (0, _auth.setToken)(token);
};
var getLanguage = function getLanguage() {
  var language = _store.default.getters.language;
  if (language) {
    if (language === "zh") {
      return "zh_CN";
    } else if (language === "en") {
      return "en_US";
    }
  }
  return "en_US";
};
// request interceptor
service.interceptors.request.use(function (config) {
  config.headers["token"] = (0, _auth.getToken)();
  config.headers["Language"] = getLanguage();
  var params = {};
  if (config.params) {
    for (var key in config.params) {
      if (config.params[key] !== null && config.params[key] !== "") {
        params[key] = config.params[key] + "";
      }
    }
  }
  config.params = _objectSpread({
    timestamp: +new Date() + "",
    nonce: Math.random().toString(36).substr(2)
  }, params);
  if (config.params.dataType == "form") {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
  }
  if (config.params.encryptType) {
    // 是否需要加密 0 不加密， 1加密
    var data = {};
    if (config.data) {
      for (var _key in config.data) {
        if (config.data[_key] !== null && config.data[_key] !== "") {
          data[_key] = config.data[_key];
        }
      }
    }
    var arr = _objectSpread(_objectSpread(_objectSpread({}, data), config.params), {}, {
      secret: "h#2TEkRTd^82+u?ch*s1qy51j%fiow8!",
      uri: config.url
    });
    var sign = {};
    // 字符串排序
    Object.keys(arr).sort().forEach(function (key) {
      sign[key] = arr[key];
    });
    var m = (0, _jsMd.default)(JSON.stringify(sign));
    config.params.sign = m.toUpperCase();
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 是否正在刷新的标记
var isRefreshing = false;
// const isAlert = null
// const key = 'updatable'
// 重试队列，每一项将是一个待执行的函数形式
var retryRequests = [];
// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (res.code === 200) {
    return res.data;
  }
  if (res && res.size > 0) {
    return res;
  }
  if (errCode.includes(res.code)) {
    (0, _auth.removeToken)();
    whiteStatus || _router.default.push("/login");
    return;
  }
  // if (res.code === 1003) { // 同一账号多次登录
  //   if (!isAlert) {
  //     isAlert = MessageBox.alert(res.msg, '提示', {
  //       confirmButtonText: '确认',
  //       showClose: false,
  //       callback: action => {
  //         if (action === 'confirm') {
  //           removeToken()
  //           router.push('/login')
  //           isAlert = null
  //           return
  //         }
  //       }
  //     })
  //   }
  // }
  // if(res.code ===400){
  //   router.push('/login')
  // }
  if (res.code === 1001) {
    // 刷新Token
    var config = response.config;
    if (!isRefreshing) {
      isRefreshing = true;
      return (0, _user.getRefreshToken)().then(function (resp) {
        var token = resp;
        service.updateToken(token);
        retryRequests.forEach(function (cb) {
          return cb(token);
        });
        retryRequests = [];
        return service(config);
      }).catch(function () {
        (0, _auth.removeToken)();
        _router.default.push("/login");
        return;
      }).finally(function () {
        isRefreshing = false;
      });
    } else {
      return new Promise(function (resolve) {
        retryRequests.push(function (token) {
          config.headers["token"] = token;
          resolve(service(config));
        });
      });
    }
  }
  // message.error({ content: res.msg, key, duration: 2 })
  _Message({
    showClose: true,
    message: res.msg,
    type: "error"
  });
  return Promise.reject(res.msg);
}, function (error) {
  _Message({
    message: JSON.stringify(error).includes("timeout") ? "请求超时" : "请求失败",
    type: "error"
  });
  return Promise.reject(error);
});
var _default = exports.default = service;